<script>
    /*
        FiltersMenu.svelte

        This is passed in a "prepared" taxonomy category with only filtered children.
        The category is really just a taxonomy top-level item.
    */

    import { onMount } from 'svelte';

    // TCARE components
    import FiltersMenuCheckbox from "./FiltersMenuCheckbox.svelte";
    import {asyncValidatePostalCode} from "../../common/utils";
    import {masterSearch} from "../../common/master-objects";
    import {isShowingZipError} from "../../stores/ScreenSettingsStore";

    export let searchStore;
    export let category;                        // a menu top-level item
    export let onSearch;

    onMount(() => {
    })

    // passed in from FiltersMenuCheckbox
    const setValue = async (source, prop, value) => {
        const isValidZipCode = await asyncValidatePostalCode($masterSearch.location.postalCode)
        if (!isValidZipCode) {
            $isShowingZipError = true
            return false
        }
        source[prop] = value;
        $searchStore = $searchStore;
        onSearch();
    }


</script>

<style>

    .filters-menu-category {
        margin-bottom: 10px;
    }

    .filters-menu-category .category-name {
        margin: 10px 0px 5px 0px;
        font-size: 15px;
        font-weight: 600;
        color: var(--tcui-primary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- children will only contain filtered nodes? -->
<div class="filters-menu-category">
    <div class="category-name">{category.label}</div>

    <!-- must check all levels of sub-categories -->
    {#each category.children as child1}

        {#if child1.isFiltered}
            <FiltersMenuCheckbox source={child1} prop={'isSelected'} setValue={setValue} label={child1.label} />
        {/if}

        {#if child1.children}
            {#each child1.children as child2}

                {#if child2.isFiltered}
                    <FiltersMenuCheckbox source={child2} prop={'isSelected'} setValue={setValue} label={child2.label} />
                {/if}

                {#if child2.children}
                    {#each child2.children as child3}

                        {#if child3.isFiltered}
                            <FiltersMenuCheckbox source={child3} prop={'isSelected'} setValue={setValue} label={child3.label} />
                        {/if}

                        {#if child3.children}
                            {#each child3.children as child4}

                                {#if child4.isFiltered}
                                    <FiltersMenuCheckbox source={child4} prop={'isSelected'} setValue={setValue} label={child4.label} />
                                {/if}

                            {/each}
                        {/if}
                    {/each}
                {/if}
            {/each}
        {/if}
    {/each}


</div>
